import { Badge } from '@apollo/orbit';
import React from 'react';

import { format } from 'src/lib/format';

type TotalCountTypes = {
  count?: number;
};

export const TotalCountBadge = ({ count }: TotalCountTypes) => (
  <Badge>{count !== undefined ? format.number(count, '0,0') : '—'}</Badge>
);
